import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

function ToastInfo({
  className,
  toastDescription
}) {
  return /*#__PURE__*/_jsx("span", {
    className: `toast-info ${className}`,
    children: toastDescription
  });
}

ToastInfo.displayName = 'ToastInfo';
export default ToastInfo;